import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Sidebar from "../components/chat/Sidebar";
import MainTopBar from "../components/chat/MainTopBar";
import ChatList from "../components/chat/ChatList";
import ChatArea from "../components/chat/ChatArea";
import CreateGroupModal from "../components/chat/CreateGroupModal";
import GroupModal from "../components/chat/GroupModal";
import { useModal } from "../ModalContext";
import styles from "../styles/chatStyles";
import GlassLoader from "../components/ui/GlassLoader";

import { db } from "../firebase";
import { doc, getDoc, setDoc, onSnapshot } from "firebase/firestore";



export default function ChatPage() {
  const [selectedChat, setSelectedChat] = useState(null);
  const [groupModalOpen, setGroupModalOpen] = useState(false);
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);
  
    const location = useLocation();

  const jumpFromNav = location.state?.jump;

  useEffect(() => {
  if (jumpFromNav) {
    setPendingJump(jumpFromNav);
  }
}, [jumpFromNav]);

  const [isCompact, setIsCompact] = useState(false);

  const [pendingJump, setPendingJump] = useState(null);
  const chatUser = location.state?.chatUser;
  const chatIdFromNav = location.state?.chatId;

  const username = localStorage.getItem("user");
  
  const { groupModal, setGroupModal } = useModal();

  // ===============================
  // 🟢 ONLINE
  // ===============================
  
  useEffect(() => {
  if (!username) return;

  const setOnline = () =>
    setDoc(
      doc(db, "users", username),
      {
        online: true,
        lastSeen: Date.now(),
      },
      { merge: true }
    );

  const setOffline = () =>
    setDoc(
      doc(db, "users", username),
      {
        online: false,
        lastSeen: Date.now(),
      },
      { merge: true }
    );

  // 🟢 сразу онлайн
  setOnline();

  // 💣 обновляем lastSeen каждые 10 сек
  const interval = setInterval(() => {
    setOnline();
  }, 10000);

  // 💀 при закрытии
  window.addEventListener("beforeunload", setOffline);

  return () => {
    clearInterval(interval);
    setOffline();
    window.removeEventListener("beforeunload", setOffline);
  };
}, [username]);
  // ===============================
  // 🔥 NORMALIZE
  // ===============================
  const normalizePrivate = (contact, userData, chatData) => ({
  id: [username, contact].sort().join("_"),
  type: "private",
  isGroup: false,
  user: {
    username: contact,
    name: userData?.name || contact,
    avatar: userData?.avatar || null,
    online: userData?.online || false,
    lastSeen: userData?.lastSeen || 0,
  },
  members: [username, contact],
  lastMessage: chatData?.lastMessage || "",
  updatedAt: chatData?.updatedAt || 0,
  typing: chatData?.typing || null,

  // 💥 ВОТ ТАК
  unread: chatData?.unread || {},
});

  const normalizeGroup = (groupId, g) => ({
  id: groupId,
  type: "group",
  isGroup: true,
  name: g?.name ?? null, // 👈 важно
  avatar: g?.avatar || null,
  members: g?.members || [],
  lastMessage: g?.lastMessage || "",
  updatedAt: g?.updatedAt || 0,
  typing: g?.typing || null,
  unread: g?.unread || {},
});

useEffect(() => {
  if (!username || !selectedChat?.id) return;

  const ref = doc(db, "users", username);

  // 🟢 зашёл в чат
  setDoc(ref, {
    viewing: selectedChat.id
  }, { merge: true });

  return () => {
    // 🔴 вышел из чата
    setDoc(ref, {
      viewing: null
    }, { merge: true });
  };

}, [selectedChat?.id]);



const unsubUser = onSnapshot(
  doc(db, "users", username),
  async (snap) => {
    if (!snap.exists()) {
      setLoading(false);
      return;
    }

    const data = snap.data();
    // ...
    setLoading(false);
  },
  (error) => {
    console.error("FIREBASE ERROR:", error);
    setLoading(false); // 💥 чтобы не зависало
  }
);

  // ===============================
  // 🔥 LOAD CHATS
  // ===============================
  useEffect(() => {
  if (!username) return;

  let chatUnsubs = [];

  const unsubUser = onSnapshot(
  doc(db, "users", username),
  async (snap) => {
   if (!snap.exists()) {
  console.log("❌ user not found in firestore:", username);
  setLoading(false); // 💥 ВАЖНО
  return;
}

    const data = snap.data();
    const contacts = data.contacts || [];
    const groups = data.groups || [];

    // 💣 чистим старые подписки
    chatUnsubs.forEach(unsub => unsub());
    chatUnsubs = [];

    // =====================
    // 🧑‍🤝‍🧑 PRIVATE
    // =====================
    for (let c of contacts) {
      const chatId = [username, c].sort().join("_");

      const unsub = onSnapshot(doc(db, "chats", chatId), async (chatSnap) => {
        const userSnap = await getDoc(doc(db, "users", c));

        const chatData = chatSnap.data() || {};
        const userData = userSnap.data() || {};

        const newChat = normalizePrivate(c, userData, chatData);

        setChats(prev => {
          const filtered = prev.filter(x => x.id !== chatId);

          return [...filtered, newChat].sort(
            (a, b) => b.updatedAt - a.updatedAt
          );
        });
      });

      chatUnsubs.push(unsub);
    }

    // =====================
    // 👥 GROUPS
    // =====================
    for (let id of groups) {
      const unsub = onSnapshot(doc(db, "chats", id), (snap) => {
        const g = snap.data() || {};

        const newChat = normalizeGroup(id, g);

        setChats(prev => {
          const filtered = prev.filter(x => x.id !== id);

          return [...filtered, newChat].sort(
            (a, b) => b.updatedAt - a.updatedAt
          );
        });
      });

      chatUnsubs.push(unsub);
    }

    setLoading(false);
  });

  return () => {
    unsubUser();
    chatUnsubs.forEach(unsub => unsub());
  };
}, [username]);

  // ===============================
  // 🔥 JUMP INIT
  // ===============================

  // ===============================
  // 🔥 OPEN CHAT
  // ===============================
useEffect(() => {
  if (!chats.length) return;
  if (!pendingJump) return; // 💥 ключевая строка

  const target = chats.find(
    (c) => c.id === pendingJump.chatId
  );

  if (target) {
    setSelectedChat(target);
  }

}, [chats, pendingJump]);

  if (loading) {
  setTimeout(() => setLoading(false), 3000); // 💥 костыль, но спасёт
  return <GlassLoader />;
}

  return (
    <div style={styles.container}>
      <Sidebar />

      <div style={styles.rightSide}>
        <MainTopBar
  onCreateGroup={() => setGroupModalOpen(true)}
  toggleChats={() => {
    if (!selectedChat) return; // 💥 блокируем
    setIsCompact(prev => !prev);
  }
}
/>

        <div style={{ display: "flex", flex: 1, minHeight: 0 }}>

  {/* 📋 CHAT LIST */}
  <div
    style={{
      width: !selectedChat
        ? "100%"
        : isCompact
        ? "80px"
        : "320px",
      transition: "0.25s",
      overflow: "hidden"
    }}
  >
    <ChatList
      chats={chats}
      selectedChat={selectedChat}
      setSelectedChat={setSelectedChat}
      mode={!selectedChat ? "full" : isCompact ? "compact" : "full"}
      isLoading={loading}
    />
  </div>

  {/* 💬 ПРАВАЯ ЧАСТЬ */}
  {!selectedChat ? (
    <div
      style={{
        width: "230px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderLeft: "1px solid rgba(255,255,255,0.08)",
        background: "rgba(255,255,255,0.02)",
      }}
    >
      <ChatArea chat={null} />
    </div>
  ) : (
    <div
      style={{
        flex: 1,
        display: "flex",
        borderLeft: "1px solid rgba(255,255,255,0.08)",
        background: "rgba(255,255,255,0.02)",
      }}
    >
      <ChatArea
  chat={selectedChat}   // 💣 ВОТ ЭТО ГЛАВНОЕ
  pendingJump={pendingJump}
  clearJump={() => setPendingJump(null)}
/>
    </div>
  )}

</div>
</div>

      {groupModalOpen && (
        <CreateGroupModal onClose={() => setGroupModalOpen(false)} />
      )}

      {groupModal && (
        <GroupModal
          group={groupModal}
          onClose={() => setGroupModal(null)}
        />
      )}
    </div>

    
  );
}